import {Component, computed, input, output} from '@angular/core';
import {AbstractControl, FormControl, ReactiveFormsModule} from '@angular/forms';
import {EditableComponent, EditableSaveResult} from '../editable/editable.component';

export interface EditableTextSaveResult extends EditableSaveResult {
  formControl: FormControl
}

@Component({
  selector: 'app-editable-text',
  imports: [
    EditableComponent,
    ReactiveFormsModule
  ],
  templateUrl: './editable-text.component.html',
  host: {
    class: 'app-container'
  }
})
export class EditableTextComponent {
  readonly control = input.required<FormControl<any>, AbstractControl<any>>(
    { transform: c => c as FormControl<any>}
  )
  readonly editMode = input<'always' | 'manual' | 'never'>('manual')
  readonly placeholder = input<string>('')
  readonly saving = output<EditableTextSaveResult>()
  readonly saved = output()
  readonly canceled = output()

  protected save($event: EditableSaveResult) {
    if (this.control().valid) {
      const result: EditableTextSaveResult = { success: true, formControl: this.control() }

      this.saving.emit(result)
    } else {
      $event.success = false
    }
  }

  protected commit() {
    this.control().markAsPristine()
    this.saved.emit()
  }

  protected cancel() {
    this.control().reset()
    this.canceled.emit()
  }
}
